<template>
	<!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
	<b-row class="mt-3">
		<b-col>
			<b-row>
				<b-col>
					<div v-if="!$store.state.isMobile" :class="getExpandClasses(u)"
						v-for="(u, uindex) in parkingRemovalList" v-bind:key="`lcrpr` + uindex + renderCounter">
						<div class="collapsible-heading">
							<div class="d-flex">
								<div class="collapsible-heading__image">
									<b-img :src="LaneClosureRequest.getLaneImage100(u.parkingLaneId.value)"></b-img>
								</div>
								<div class="flex-grow-1 collapsible-heading__title">
									{{ LaneClosureRequest.getLaneText(u.parkingLaneId.value) }}
									<br />
									<small>{{ u.parkingStartAddress.value }} to {{
										u.parkingEndAddress.value }}</small>
									<small>&nbsp;({{ u.parkingRemovalMetres.value }} metres) </small>
									<br />
								</div>
							</div>
						</div>
					</div>
					<!-- End of desktop -->

					<div v-if="$store.state.isMobile"
						:class="isExpanded(u) ? 'collapsible expanded collapsible__lane' : 'collapsible collapsible__lane collapsed'"
						v-for="(u, uindex) in parkingRemovalList" v-bind:key="`lcrpr` + uindex + '-' + renderCounter">
						<div class="collapsible-heading">
							<div class="d-flex">
								<div class="collapsible-heading__image">
									<b-img :src="LaneClosureRequest.getLaneImage100(u.parkingLaneId.value)"></b-img>
								</div>
								<div class="flex-grow-1 collapsible-heading__title">
									{{ LaneClosureRequest.getLaneText(u.parkingLaneId.value) }}
									<div class="collapsible-heading__subtitle">{{ u.parkingStartAddress.value }} to {{
										u.parkingEndAddress.value }} ({{ u.parkingRemovalMetres.value }} metres)</div>
								</div>
							</div>
						</div>
					</div>
					<!-- End of mobile -->
				</b-col>
			</b-row>
		</b-col>
	</b-row>
</template>

<script>
import LaneClosureRequest from './../models/LaneClosureRequest.js'

export default {
	name: 'LaneClosureRequestParkingRemovalListing',
	props: ['renderCounter', 'parkingRemovalList'],
	components: {
	},
	data() {
		return {
			LaneClosureRequest: LaneClosureRequest,
		}
	},
	mounted() {

	},
	destroyed() {
	},
	watch: {


	},
	computed: {


	},
	methods: {

		getExpandClasses(obj) {
			if (obj) {
				if (obj.expand) {
					return "collapsible expanded collapsible__lane";
				}
			}
			return "collapsible collapsible__lane collapsed";
		},
		isExpanded(u) {
			if (u) {
				if (typeof u.expand != "undefined") {
					return u.expand;
				}
			}
			return false;
		},
		classes: function (index, uindex) {
			if (this.isEntry(index, uindex)) {
				return "is-entry";
			} else {
				return "is-not-entry";
			}
		},

	}
}
</script>
